import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['phoneSection', 'channelInput']

  connect() {
    this.update()
  }

  phoneSectionTargetConnected(element) {
    this.applyChannelTo(element, this.currentChannel() === 'sms')
  }

  update() {
    const isSms = this.currentChannel() === 'sms'
    this.phoneSectionTargets.forEach((section) => {
      this.applyChannelTo(section, isSms)
    })
  }

  applyChannelTo(section, isSms) {
    section.classList.toggle('hidden', !isSms)
    // Toggle `required` only on inputs that can carry HTML5 validation:
    // - skip type="hidden" (not focusable → "An invalid form control... is not focusable")
    // - skip nameless inputs (the intl-tel-input visible input has no name → "name=''" warning)
    // The visible tel input would need a `name` to be eligible; adding one
    // is tracked separately. For now we drop the client-side required and
    // let the server-side check handle SMS-without-phone.
    section.querySelectorAll('input').forEach((input) => {
      if (input.type === 'hidden' || !input.name) {
        input.required = false
        return
      }
      input.required = isSms
    })
  }

  currentChannel() {
    const checked = this.channelInputTargets.find((input) => input.checked)
    return checked ? checked.value : 'email'
  }
}
